import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Flex,
  Text,
  Button,
  Spinner
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { IconChevronUp, IconChevronDown } from "@tabler/icons-react";

const MotionBox = motion(Box);

const HowDsWork = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => setIsExpanded((prev) => !prev);

  return (
    <Box  width="100%" py={12} px={4} 
  
            >
      <Container maxW="1200px" mx="auto">
        {/* Heading */}
        <Box   bg="rgba(255,255,255,0.05)"
             textAlign="center" mb={16} position="relative">
          <Text
            fontSize="4rem"
            fontWeight="bold"
            color="#B67300"
            textShadow="0 0 10px rgba(255,255,255,0.7)"
            fontFamily="cursive"
          >
            How We Work
          </Text>
          <Box height="3px" width="300px" bg="#B67300" mx="auto" mt={2} borderRadius="full" />
        </Box>

        {/* Steps */}
        <Grid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }} gap={8} mt={10}>
          {/* Step 1 */}
          <Box position="relative" mb={10}   bg="rgba(255,255,255,0.05)"
            >
            <Box
              bg="#B67300"
              width="70px"
              height="70px"
              borderRadius="4px"
              mb={4}
              display="flex"
              justifyContent="center"
              alignItems="center"
              transform="rotate(-5deg)"
              boxShadow="3px 3px 0px rgba(0,0,0,0.2)"
              padding={0}
              margin={5}
            >
              <Text fontSize="2.5rem" fontWeight="bold" color="white">
                1
              </Text>
            </Box>
            <Text margin={5} fontSize="1.8rem" fontWeight="bold" color="black" mb="1rem">
              INTERIOR DEMOLITION
            </Text>
            <Text margin={5} fontSize="1rem" color="black" lineHeight="1.6">
              From gutting kitchens and bathrooms to stripping out commercial spaces, we handle all aspects of interior demolition with precision. We protect what needs to stay and remove what needs to go—down to the last nail.
            </Text>
          </Box>

          {/* Step 2 - Expandable */}
         <Box position="relative" mb={10}   bg="rgba(255,255,255,0.05)"
            >
            <Box
              bg="#B67300"
              width="70px"
              height="70px"
              borderRadius="4px"
              mb={4}
              display="flex"
              justifyContent="center"
              alignItems="center"
              transform="rotate(-5deg)"
              boxShadow="3px 3px 0px rgba(0,0,0,0.2)"
              padding={0}
              margin={5}
            >
              <Text fontSize="2.5rem" fontWeight="bold" color="white">
                2
              </Text>
            </Box>
            <Text margin={5} fontSize="1.8rem" fontWeight="bold" color="black" mb="1rem">
              EXTERIOR DEMOLITION
            </Text>
            <Text margin={5} fontSize="1rem" color="black" lineHeight="1.6">
             Wheather it's a garage. shed or entire building our exterior demolition services are thorough and safe. we handle everything from tear-downs to clean-up, ensuring the site is ready for the next phaase of construction.
             
             
              </Text>
          </Box>

          {/* Step 3 */}
          <Box position="relative" mb={10}   bg="rgba(255,255,255,0.05)"
            >
            <Box
              bg="#B67300"
              width="70px"
              height="70px"
              borderRadius="4px"
              mb={4}
              display="flex"
              justifyContent="center"
              alignItems="center"
              transform="rotate(-5deg)"
              boxShadow="3px 3px 0px rgba(0,0,0,0.2)"
               padding={0}
              margin={5}
            >
              <Text margin={5} fontSize="2.5rem" fontWeight="bold" color="white">
                3
              </Text>
            </Box>
            <Text margin={5} fontSize="1.8rem" fontWeight="bold" color="black" mb="1rem">
              SPOTLESS CLEAN-UP
            </Text>
            <Text margin={5} fontSize="1rem" color="black" lineHeight="1.6">
              We're not just demolition experts—we're cleanup specialists. We take pride in our reputation for leaving sites immaculate. No debris, no hazards—just a clean, safe site ready for the next trades to come in.
            </Text>
          </Box>
        </Grid>

        {/* Bottom Title */}
        {/* <Box mt={16} mb={8}>
          <Text
            fontSize="3.5rem"
            fontWeight="bold"
            color="black"
            WebkitTextStroke="1px white"
            letterSpacing="2px"
            lineHeight="1"
          >
            DEMOLITION EXPERTS
          </Text>
        </Box> */}
      </Container>
    </Box>
  );
};

export default HowDsWork;
